module.exports = __webpack_public_path__ + "static/media/cert_138.60c8f761.jpg";